import type { AskResponse } from './searchTypes';

interface AskErrorResponse {
  error?: string | { code?: string; message?: string };
  message?: string;
}

export class AskSearchError extends Error {
  constructor(
    message: string,
    readonly code: string,
  ) {
    super(message);
  }
}

export async function requestAnswer(
  query: string,
  conferenceId: string,
  signal?: AbortSignal,
): Promise<AskResponse> {
  const response = await fetch('/api/v2/search/ask', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ query, conferenceId }),
    signal,
  });
  const payload = (await response.json().catch(() => ({}))) as
    | AskResponse
    | AskErrorResponse;
  if (
    !response.ok ||
    !('answer' in payload) ||
    !Array.isArray(payload.passages)
  ) {
    const error = payload as AskErrorResponse;
    const details = typeof error.error === 'object' ? error.error : undefined;
    throw new AskSearchError(
      details?.message ?? error.message ?? 'Question answering is unavailable.',
      details?.code ??
        (response.status === 401
          ? 'AUTH_REQUIRED'
          : response.status === 403 && error.error === 'ai_access_denied'
            ? 'AI_ACCESS_DENIED'
          : response.status === 429
            ? 'AI_SEARCH_DAILY_LIMIT_REACHED'
            : 'ASK_FAILED'),
    );
  }
  return payload;
}
